module.exports = function() {
  return new Worker(__webpack_public_path__ + "eebe21ee4a5d2592677b.worker.js");
};